import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = {};

const formatData = (state, meta, leaf) => {
  const { key, field } = meta;
  const value = meta[field];

  return {
    ...state,
    [key]: {
      ...(state[key] ?? {}),
      [field]: {
        ...(state[key]?.[field] ?? {}),
        [value]: {
          ...(state[key]?.[field]?.[value] ?? {}),
          ...leaf,
        },
      },
    },
  };
};

const beforeFetchData = (state, { meta }) => formatData(state, meta, { isLoading: true, apiError: null });

const updateTop = (state, { payload, meta }) => {
  const { reducer } = meta;
  const { [reducer]: displayName, links, ...data } = payload;
  return formatData(state, meta, { ...data, displayName, isLoading: false, apiError: null });
};

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_TOP_ANYTHING]: beforeFetchData,
  [types.FETCH_STATISTICS_TOP_ANYTHING_SUCCESS]: updateTop,
});
